module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAcCAYAAABVo158AAABGklEQVQ4T63Uvy4FQRTH8e8vUaiUotN5ADUJUaHQiFYi8QruK4h3EB5ARKfyJ1GKnk4obkGnobh+cjZD5o5dd/fGdLszn5z5c86R7T1JB7Qcsv0J7Eo6bGMCGBgAW5JOR6FvEOs+gHVJF3+hHMS6N2BF0m0TKkGsewUWJd3XoQCPwGwx+QwsSHoqUYA54AaYLiYfUqSX/L/iw/Y8cAVMFegOWJYUZ6tGBRJaAs6ByQJdA6uS3odAQhvACTBRoDNgU9LgJ0IWaRs4yqOnuWNg5xdIkfaBXs219prADNCvAf1/A+23ZLv9oW23v1bbTQ8XGbA29HCdUqNz8o2T3lHT+RhZQDnoVKLRBOI2LpvquUrvcdpM50bWqVV+Afa+msVCvxjuAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/static/img/set_img/icon_sj_white_v2.png
// module id = 258
// module chunks = 1